/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum CarrierActivationStatus {
  Active = "Active",
  Deprecated = "Deprecated",
  UnderConstruction = "UnderConstruction",
}

export function instanceOfCarrierActivationStatus(value: any): boolean {
  for (const key in CarrierActivationStatus) {
    if (Object.prototype.hasOwnProperty.call(CarrierActivationStatus, key)) {
      if (
        CarrierActivationStatus[key as keyof typeof CarrierActivationStatus] ===
        value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function CarrierActivationStatusFromJSON(
  json: any,
): CarrierActivationStatus {
  return CarrierActivationStatusFromJSONTyped(json, false);
}

export function CarrierActivationStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierActivationStatus {
  return json as CarrierActivationStatus;
}

export function CarrierActivationStatusToJSON(
  value?: CarrierActivationStatus | null,
): any {
  return value as any;
}

export function CarrierActivationStatusToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): CarrierActivationStatus {
  return value as CarrierActivationStatus;
}
